import React from 'react';
import {Text} from 'components/core';


const minute = 1000 * 60;
const hour = minute * 60;
const day = hour * 24;
type SmartDateLabelPrecission = 'minute' | 'hour' | 'day';

type SmartLabelProps =  {
    datetime: string | undefined | null, 
    unformatted: boolean | undefined, 
    precission: SmartDateLabelPrecission;
    props: any
}
type SplitDateTime = {
    month?: string,
    date?: string,
    year?: string,
    hour?: string,
    minute?: string,
    second?: string
}



export default function SmartDateLabel({datetime, unformatted, precission = 'minute', ...props} : SmartLabelProps)
{
    const [triggerRender, setTriggerRender] = React.useState(1) // default value can be anything you want

    React.useEffect(() => {
        setTimeout(() => setTriggerRender(triggerRender+1), 60000);
    }, [triggerRender]);

    let text = "";
    if(!datetime)
    {
        text = "Nunca";
    }
    else
    {
        const dtObj = new Date(datetime);
        let today : SplitDateTime = {};
        [today.month, today.date, today.year]    = new Date().toLocaleDateString("en-US").split("/");
        [today.hour, today.minute, today.second] = new Date().toLocaleTimeString("en-US").split(/:| /);

        let dt : SplitDateTime = {};
        [dt.month, dt.date, dt.year]    = dtObj.toLocaleDateString("en-US").split("/");
        [dt.hour, dt.minute, dt.second] = dtObj.toLocaleTimeString("en-US").split(/:| /);

        let diff = new Date().getTime() - dtObj.getTime();
        
        
        if(diff < 0) // its a future date
        {
            diff = -diff; // reverse the difference to positive values, it's easier to understand

            // default, set the date. Overwrite based on precission and proximity
            text = `${dt.date}/${dt.month}/${dt.year}`;
            if(diff/day < 3) // if it's less than 3 days, check by date instead of time diff
            {
                if(today.date === dt.date) text = "Hoy";
                else
                {
                    if(today.month === dt.month)
                    {
                        if(parseInt(today.date)+1 === parseInt(dt.date)) text = "Mañana";
                    }
                    else if(dt.date === '1') text = "Mañana";
                }
            } 
            
            
            if(precission !== 'day' && diff < day)
            {
                text = `Dentro de ${Math.floor(diff/hour)} horas`;
                if(diff < hour * 2) text = "Dentro de 1 hora";
                if(diff< hour) text = "Ahora";

                if(precission === 'minute' && diff < hour)
                {
                    text = `Dentro de ${Math.floor(diff/minute)} minutos`;
                    if(diff < minute * 2) text = "Dentro de 1 minuto";
                    if(diff < minute) text = "Ahora"
                }
            }



            // if(precission === 'day' && diff < day)
            // {
            //     text = "Hoy"
            // }
            // else if(diff > minute) text = "Ahora";
            // else if(diff > hour)
            // {
            //     if(diff/minute > 2) text = "Dentro de 1 minuto";
            //     else text = `Dentro de ${Math.floor(diff/minute)} minutos`;
            // }
            // else if(diff > day)
            // {
            //     if(diff/hour > 2) text = "Dentro de 1 hora";
            //     else text = `Dentro de ${Math.floor(diff/hour)} horas`;
            // }
            // else
            // {
            //     if(diff/day > 2) text = "Mañana";
            //     else text = `${dt.date}/${dt.month}/${dt.year}`;
            // }
        }
        else
        {
            // default, set the date. Overwrite based on precission and proximity
            text = `${dt.date}/${dt.month}/${dt.year}`;
            if(diff/day < 3) // if it's less than 3 days, check by date instead of time diff
            {
                if(today.date === dt.date) text = "Hoy";
                else
                {
                    if(today.month === dt.month)
                    {
                        if(parseInt(today.date)-1 === parseInt(dt.date)) text = "Ayer";
                    }
                    else if(today.date === '1') text = "Ayer";
                }
            } 
            if(diff/day < 2) text = "Ayer";
            if(diff/day < 1) text = "Hoy";
            
            if(precission !== 'day' && diff < day)
            {
                text = `Hace ${Math.floor(diff/hour)} horas`;
                if(diff < hour * 2) text = "Hace 1 hora";
                if(diff < hour) text = "Ahora";

                if(precission === 'minute' && diff < hour)
                {
                    text = `Hace ${Math.floor(diff/minute)} minutos`;
                    if(diff < minute * 2) text = "Hace 1 minuto";
                    if(diff < minute) text = "Ahora"
                }
            }

            // if(diff < minute) text = "Ahora";
            // else if(diff < hour)
            // {
            //     if(diff/minute < 2) text = "Hace 1 minuto";
            //     else text = `Hace ${Math.floor(diff/minute)} minutos`;
            // }
            // else if(diff < day)
            // {
            //     if(diff/hour < 2) text = "Hace 1 hora";
            //     else text = `Hace ${Math.floor(diff/hour)} horas`;
            // }
            // else
            // {
            //     if(diff/day < 2) text = "Ayer";
            //     else text = `${dt.date}/${dt.month}/${dt.year}`;
            // }
        }
    }


    if(unformatted) return text;
    return <Text {...props}>{text}</Text>;
}